import { SessionManager } from "../session/SessionManager";

/** Verified parent origin from verifyOrigin; used as postMessage targetOrigin. */
let _verifiedOrigin = null;

/**
 * Set the verified parent origin after successful verifyOrigin.
 * Used for secure postMessage targetOrigin and to validate incoming messages.
 */
export function setVerifiedParentOrigin(origin) {
	_verifiedOrigin = origin;
}

/**
 * Get the verified parent origin (null if not yet verified).
 */
export function getVerifiedParentOrigin() {
	return _verifiedOrigin;
}

/**
 * Post message to parent window using verified origin when set, otherwise "*".
 */
export function postToParent(message) {
	window.parent.postMessage(message, _verifiedOrigin ?? "*");
}

/**
 * Notify host that origin is verified and widget can be shown.
 * Marks SessionManager ready to process queued session events.
 */
export function showMessenger() {
	postToParent({ type: "originVerified" });
	SessionManager.setReady();
}

/**
 * Notify host to hide the widget iframe.
 */
export function hideMessengerFrame() {
	postToParent({ hideWidget: true });
}

/** Host bridge: widget → parent postMessage API (resize, ui_state, etc.). */

export function resizeFrame(dimensions, position) {
	postToParent(position ? { resize: true, dimensions, position } : { resize: true, dimensions });
}

export function uiState(view) {
	postToParent({ type: "ui_state", view });
}

export function welcomePopover(show, buttonSize) {
	postToParent({ type: "welcomePopover", show, buttonSize });
}

export function updateButtonPosition(position) {
	postToParent({ type: "updateButtonPosition", position });
}

export function fullscreenState(isFullscreen) {
	postToParent({ type: "fullscreenState", isFullscreen });
}

export function toggleFullscreen() {
	postToParent({ type: "toggleFullscreen" });
}

export function updateVoiceDimensions() {
	postToParent({ updateVoiceDimensions: true });
}
